export const BoxComp = props =>{
    return <div className="boxEffect">
    <div className="leftline line"></div>
    <div className="rightline line"></div>
    <div className="topline line"></div>
    <div className="bottomline line"></div>
    <div className="boxlogo"><div className="boxInsideBox"><div className="logoInsideBox"></div></div></div>
    <div className="half-circle"></div>
    <div className="menuBtn" onClick={()=>props.lateralMenu.current.showLateralMenu(true)}>
      <div className="insideMenucircleBtn">Menu</div></div>
  </div> 
}

export default BoxComp